import Banner from './banner'
import { WarningIcon } from './icons'

const WarningBanner: React.FC<Nothing> = () => {
  return (
    <Banner background="#fcf5d8">
      <WarningIcon />
    </Banner>
  )
}

export default WarningBanner
